import React, { useState, useEffect } from "react";
import { Context } from "../backend/context";

import { connect } from "react-redux";

function BotOrderDetails(props) {
  const { bots } = React.useContext(Context);
  const [bot, setBot] = useState(null);
  const [addiData, setAddiData] = useState({});
  const [pendingOrders, setpendingOrders] = useState([]);
  const [filledOrders, setfilledOrders] = useState([]);
  const [cancelledOrders, setcancelledOrders] = useState([]);

  useEffect(() => {
    var id = props.id;
    // console.log(id);
    var isAva = false;
    bots.forEach((element) => {
      if (element.id === id) {
        setBot(element);

        isAva = true;
        return;
      }
    });
    if (!isAva) {
      setBot(null);
    }
    var x;
    for (x in props.pendingOrders) {
      if (props.pendingOrders[x].key === id) {
        setpendingOrders(props.pendingOrders[x].data.sort(compare));
      }
    }

    for (x in props.filledOrders) {
      if (props.filledOrders[x].key === id) {
        setfilledOrders(props.filledOrders[x].data.sort(compare));
      }
    }

    for (x in props.cancelledOrders) {
      if (props.cancelledOrders[x].key === id) {
        setcancelledOrders(props.cancelledOrders[x].data.sort(compare));
      }
    }
    for (x in props.volumeNprofitData) {
      if (props.volumeNprofitData[x].key === id) {
        setAddiData(props.volumeNprofitData[x]);
      }
    }
  }, [bots, props]);

  function compare(a, b) {
    if (new Date(a.placedAt) < new Date(b.placedAt)) {
      return 1;
    }
    if (new Date(a.placedAt) > new Date(b.placedAt)) {
      return -1;
    }
    return 0;
  }

  return (
    <React.Fragment>
      {bot !== null && (
        <React.Fragment>
          <div className="row mb-3">
            <div className="col-11 m-auto border border-black rounded-lg badge-dark p-2">
              <div className="row">
                <div className="col-10 m-auto">
                  Trading Volume : $
                  {addiData.volume && addiData.volume.toFixed(2)}
                </div>
              </div>
              <div className="row">
                <div className="col-10 m-auto">
                  Profit : ${addiData.profit && addiData.profit.toFixed(2)}
                </div>
              </div>
            </div>
          </div>
          <div className="row mb-3">
            <div className="col-11 pl-5  m-auto border border-black rounded-lg badge-dark py-2">
              Bot ID : {bot.displayId}
            </div>
          </div>
          <div className="row">
            <div className="col-11 m-auto border border-black rounded-lg badge-dark py-2 text-center">
              <div
                className="row"
                style={{
                  maxHeight: "300px",
                  overflowY: "auto",
                  overflowX: "auto",
                }}
              >
                <div
                  className="col-12"
                  style={{
                    minWidth: "700px",
                  }}
                >
                  <div className="row border-black border-bottom">
                    <div className="col-10 m-auto text-left pb-2">
                      Pending Orders
                    </div>
                  </div>
                  <div className="row border-black border-bottom">
                    <div className=" border-right border-black col-4">Date</div>
                    <div className=" border-right border-black col-2 overflow-hidden">
                      Type
                    </div>
                    <div className=" border-right border-black col-3 overflow-hidden">
                      Price
                    </div>
                    <div className=" border-right border-black col-3 overflow-hidden">
                      Amount
                    </div>
                  </div>
                  {pendingOrders.length > 0 ? (
                    pendingOrders.map((item, key) => (
                      <div key={key} className="row border-black border-bottom">
                        <div
                          className=" border-right border-black col-4 text-left"
                          style={{ fontSize: "0.75rem" }}
                        >
                          {item.placedAt &&
                            new Date(item.placedAt).toLocaleString()}
                        </div>
                        <div className=" border-right border-black col-2 overflow-hidden">
                          {item.type}
                        </div>
                        <div className=" border-right border-black col-3 overflow-hidden">
                          {parseFloat(item.price)}
                        </div>
                        <div className=" border-right border-black col-3 overflow-hidden">
                          {parseFloat(
                            parseFloat(item.amount.amount).toFixed(8)
                          )}
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className="row border-black border-bottom">
                      <div className=" border-right border-black col-12">
                        No Orders
                      </div>
                    </div>
                  )}
                  <div className="row border-black border-bottom mt-3">
                    <div className=" col-10 m-auto py-2   text-left">
                      Filled Orders
                    </div>
                  </div>
                  <div className="row border-black border-bottom">
                    <div className=" border-right border-black col-3 overflow-hidden">
                      Date
                    </div>
                    <div className=" border-right border-black col-2 overflow-hidden">
                      Exchange
                    </div>{" "}
                    <div className=" border-right border-black col-2 overflow-hidden">
                      Type
                    </div>
                    <div className=" border-right border-black col-2 overflow-hidden">
                      Price
                    </div>
                    <div className=" border-right border-black col-3 overflow-hidden">
                      Amount
                    </div>
                  </div>
                  {filledOrders.length > 0 ? (
                    filledOrders.map((item, key) => (
                      <div key={key} className="row border-black border-bottom">
                        <div
                          className=" border-right border-black col-3 overflow-hidden text-left"
                          style={{ fontSize: "0.75rem" }}
                        >
                          {new Date(item.filledAt).toLocaleString()}
                        </div>
                        <div className=" border-right border-black col-2 overflow-hidden">
                          {item.exchange ? item.exchange : "Nash"}
                        </div>{" "}
                        <div className=" border-right border-black col-2 overflow-hidden">
                          {item.buyOrSell}
                        </div>
                        <div className=" border-right border-black col-2 overflow-hidden">
                          {parseFloat(item.limitPrice.amount)}
                        </div>
                        <div className=" border-right border-black col-3 overflow-hidden">
                          {parseFloat(item.amount.amount)}
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className="row border-black border-bottom">
                      <div className=" border-right border-black col-12">
                        No Orders
                      </div>
                    </div>
                  )}
                  <div className="row border-black border-bottom mt-3">
                    <div className="col-10 m-auto text-left pb-2">
                      Cancelled Orders
                    </div>
                  </div>
                  <div className="row border-black border-bottom">
                    <div className=" border-right border-black col-4">Date</div>
                    <div className=" border-right border-black col-2 overflow-hidden">
                      Type
                    </div>
                    <div className=" border-right border-black col-3 overflow-hidden">
                      Price
                    </div>
                    <div className=" border-right border-black col-3 overflow-hidden">
                      Amount
                    </div>
                  </div>
                  {cancelledOrders.length > 0 ? (
                    cancelledOrders.map((item, key) => (
                      <div key={key} className="row border-black border-bottom">
                        <div
                          className=" border-right border-black col-4 text-left"
                          style={{ fontSize: "0.75rem" }}
                        >
                          {new Date(item.placedAt).toLocaleString()}
                        </div>
                        <div className=" border-right border-black col-2 overflow-hidden">
                          {item.buyOrSell}
                        </div>
                        <div className=" border-right border-black col-3 overflow-hidden">
                          {parseFloat(item.limitPrice.amount)}
                        </div>
                        <div className=" border-right border-black col-3 overflow-hidden">
                          {parseFloat(item.amount.amount)}
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className="row border-black border-bottom">
                      <div className=" border-right border-black col-12">
                        No Orders
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </React.Fragment>
      )}
    </React.Fragment>
  );
}

const mapStateToProps = (state) => ({
  volumeNprofitData: state.volumeNprofit.data,
  pendingOrders: state.pendingOrders.data,
  filledOrders: state.filledOrders.data,
  cancelledOrders: state.cancelledOrders.data,
});

export default connect(mapStateToProps)(BotOrderDetails);
